import { z } from "zod";
import { BaseOverlayConfig } from "../shared/config";
import { defineOverlay } from "../shared/functions";
const themes = ["bac", "regular"];
const positions = ["top", "bottom"];
export const DonationTrainOverlay = defineOverlay({
    defaults: {
        demoMode: false,
        maxTrainsVisible: 1,
        position: "bottom",
        removeTrailingZeroes: true,
        theme: "regular",
        truncateNames: false,
    },
    details: {
        category: "overlays",
        description: "Incentivize your viewers to donate to your fundraising campaign by acknowledging donations to your fundraising stream.",
        features: [],
        flags: {
            isFeatured: false,
            isNew: true,
            isUpdated: false,
            isVisible: true,
        },
        icon: "overlays/donation-train.png",
        name: "Donation Train",
        path: "/overlays/donation-train",
        shortDescription: "Incentivize your viewers to donate to your fundraising campaign by acknowledging donations to your fundraising stream.",
        slug: "donation-train",
    },
    schema: BaseOverlayConfig.extend({
        maxTrainsVisible: z
            .number()
            .int()
            .min(1)
            .max(10)
            .default(() => DonationTrainOverlay._config.defaults.maxTrainsVisible)
            .optional(),
        position: z
            .enum(positions)
            .default(() => DonationTrainOverlay._config.defaults.position)
            .optional(),
        removeTrailingZeroes: z
            .boolean()
            .default(() => DonationTrainOverlay._config.defaults.removeTrailingZeroes)
            .optional(),
        theme: z
            .enum(themes)
            .default(() => DonationTrainOverlay._config.defaults.theme)
            .optional(),
        truncateNames: z
            .boolean()
            .default(() => DonationTrainOverlay._config.defaults.truncateNames)
            .optional(),
    }),
});
//# sourceMappingURL=donation-train.js.map